import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    active_sidebar: true
  };
  
  const changeMenuStateSlice = createSlice({
    name: 'sidebar',
    initialState: initialState,
    reducers: {
      toggleSidebar: (state) => {
        if(state.active_sidebar == true){
            state.active_sidebar = false
        }else{
            state.active_sidebar = true
        }
      }
    }
  });
  
  export const { toggleSidebar } = changeMenuStateSlice.actions;
  
  export default changeMenuStateSlice.reducer;